import { render } from "./FreeTradeBuy.vue?vue&type=template&id=2e04fc46&ts=true"
import script from "./FreeTradeBuy.vue?vue&type=script&lang=ts"
export * from "./FreeTradeBuy.vue?vue&type=script&lang=ts"

import "./FreeTradeBuy.vue?vue&type=style&index=0&id=2e04fc46&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__